import { render } from "./MButton.vue?vue&type=template&id=cae517ee&scoped=true&ts=true"
import script from "./MButton.vue?vue&type=script&lang=ts"
export * from "./MButton.vue?vue&type=script&lang=ts"

import "./MButton.vue?vue&type=style&index=0&id=cae517ee&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae517ee"]])

export default __exports__